import DomComponent from '../../lib/domComponent';
import { mq } from '../../lib/util';
import { widgetSpacing } from '../../lib/const';

export default class BgImgComponent extends DomComponent {
    static selector = '[data-js-bg-img]'
    carouselWidget;
    gridWidget;

    constructor(el, graphicalCalloutGrid, graphicalCalloutCaorusel) {
        super(el);

        if (!this.el || !graphicalCalloutCaorusel || !graphicalCalloutGrid) {
            return;
        }
        this.carouselWidget = graphicalCalloutCaorusel;
        this.gridWidget = graphicalCalloutGrid;

        this.calculateBackgroundHeight();


        window.addEventListener('resize', this.calculateBackgroundHeight.bind(this));

        setTimeout(() => {
            this.loaded();
        })
    }

    calculateBackgroundHeight(){
        const hero = document.querySelector('.hero');

        if(this.carouselWidget && this.gridWidget && hero){
            this.el.style.top = hero.offsetHeight + 'px';
            this.el.style.height = this.carouselWidget.offsetHeight
                + this.gridWidget.offsetHeight
                + 'px';
        }
    }
}